import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { DeleteAccountWebhookMutation, Scalars } from '@/gql/graphql';

const DELETE_ACCOUNT_WEBHOOK_MUTATION = graphql(`
  mutation DeleteAccountWebhook($id: ID!) {
    deleteWebhook(webhookId: $id)
  }
`);

const useDeleteAccountWebhook = (
  options?: UseMutationOptions<
    DeleteAccountWebhookMutation,
    unknown,
    Scalars['ID']['input']
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => {
      return gqlClient.request(DELETE_ACCOUNT_WEBHOOK_MUTATION, { id });
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountWebhooks(),
      });
    },
    ...options,
  });
};

export default useDeleteAccountWebhook;
